<template>
    <div class="alert_overlay" @click="onCancel">
        <div class="alert_card" :class="themeClass" @click.stop>
            <div class="beta_badge">BETA</div>
            <div class="alert_title">{{ title }}</div>
            <div class="alert_contents" v-html="contents"></div>
            <div class="alert_btns" :class="{ single: !cancelName }">
                <div v-if="cancelName" class="alert_btn cancel" @click="onCancel">{{ cancelName }}</div>
                <div class="alert_btn ok" @click="onOk">{{ okName }}</div>
            </div>
        </div>
    </div>
</template>

<script>    
export default {
    name: 'CommonAlertUi',
    props: {
        title: {
            type: String,
            default: ''
        },
        contents: {
            type: String,
            default: ''
        },
        okName: {
            type: String,
            default: '확인'
        },
        cancelName: {
            type: String,
            default: null
        },
        okAction: {
            type: Function,
            default: null
        },
        cancelAction: {
            type: Function,
            default: null
        },
        theme: {
            type: String,
            default: 'secret' // secret | public | continue
        }
    },
    computed: {
        themeClass() {
            if (this.theme === 'public') return 'theme_public'
            if (this.theme === 'continue') return 'theme_continue'
            return 'theme_secret'
        }
    },
    mounted() {
        this.$GlobalStore.addPopFlag(() => {
            this.onCancel();
        });
    },
    methods: {
        onOk() {
            if (typeof this.okAction === 'function') {
                this.okAction();
            }
            this.$GlobalStore.closeLastModal();
        },
        onCancel() {
            if (typeof this.cancelAction === 'function') {
                this.cancelAction();
            }
            this.$GlobalStore.closeLastModal();
        }
    }
}
</script>

<style scoped>
.alert_overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.alert_card {
    width: calc(100% - 24px);
    background: #fff;
    border-radius: 24px;
    padding: 30px 16px;
    box-sizing: border-box;
    text-align: center;
}

.beta_badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    padding: 0 8px;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
}

.theme_secret .beta_badge {
    background: linear-gradient(90deg, #D230FE 0%, #7179EC 100%);
}

.theme_public .beta_badge {
    background: linear-gradient(90deg, #FF7111 0%, #FFB347 100%);
}

.theme_continue .beta_badge {
    background: linear-gradient(90deg, #1F59E8 0%, #4A8AFF 100%);
}

.alert_title {
    margin-top: 14px;
    font-size: 18px;
    font-weight: 700;
    line-height: 26px;
    color: #210F03;
}

.alert_contents {
    margin-top: 5px;
    font-size: 14px;
    line-height: 22px;
}

.alert_contents >>> span {
    font-weight: 700;
}

.alert_btns {
    display: flex;
    gap: 8px;
    margin-top: 22px;
}

.alert_btns.single .alert_btn.ok {
    flex: 1;
}

.alert_btn {
    flex: 1;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    box-sizing: border-box;
}

.alert_btn.cancel {
    background: #F5F5F5;
    color: #210F03;
}

.theme_secret .alert_btn.ok {
    background: #9E4CF6;
    color: #fff;
}

.theme_public .alert_btn.ok {
    background: #FF7111;
    color: #fff;
}

.theme_continue .alert_btn.ok {
    background: #1F59E8;
    color: #fff;
}
</style>
